module.exports = __webpack_public_path__ + "img/1509.d0f6f963.gif";